'use strict';

/**
 * @classname Accordion
 * @classdesc アコーディオン
 */
export default class Accordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - .accordion
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$answer = $e.closest('.accordion-wrap').find('.accordion-target');
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof Accordion
	 * @return undefined
	 */
	onClick() {
		this._$e.toggleClass('open');
	}
};
